const ADMIN_TABLE_PERSISTENCE_PREFIX = `admin:table:v1:`;

export function getAdminTablePersistenceKey(
  tableName: string,
  userId: number | string | null | undefined
) {
  const resolvedUserId = userId ?? 'anonymous';
  return `${ADMIN_TABLE_PERSISTENCE_PREFIX}${tableName}:user-${resolvedUserId}`;
}

export function clearAdminTablePersistence(userId: number | string | null | undefined) {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') return;

  const userSuffix = userId === null || userId === undefined ? null : `:user-${userId}`;
  const keysToRemove: string[] = [];

  for (let index = 0; index < localStorage.length; index++) {
    const key = localStorage.key(index);
    if (!key?.startsWith(ADMIN_TABLE_PERSISTENCE_PREFIX)) continue;
    if (userSuffix && !key.endsWith(userSuffix)) continue;

    keysToRemove.push(key);
  }

  for (const key of keysToRemove) {
    localStorage.removeItem(key);
  }
}
